module.exports = __webpack_public_path__ + "static/whiteteddyhamper-69ce5ee2583a94a45b4d2a25f4a4fb25.jpeg";